export const iconFontAwesomeMedicalHealthWeightScale = (
	<i className="fa-solid fa-weight-scale"></i>
);
